/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { IUserAuth } from "../interfaces/IUserAuth";
import { IAuthAWS } from "../interfaces/IAuthAWS";
import {
  IAuthFunctionalities,
  SocialMedia,
} from "../interfaces/IAuthFunctionalities";
import { store } from "../store/rootStore";
import {
  getCurrentClinician,
  clearCurrentClinician,
} from "store/ClinicianStore/actions";
import { clearCurrentPatientRegion } from "store/PatientRegionsStore/actions";
// import { DefaultTheme } from "react-native-paper";

import * as cognito from "../libs/cognito";
import { initGlobalConfig } from "../core/theme";
import { IMessage } from "../interfaces/IMessage";
import sendMessage from "../core/flash-message";
import { IAuth, AuthStatus } from "../interfaces/IAuth";
import { USER_GROUPS } from "constants/roles";
import { AuthRepository } from "repositories/AuthRepository";
import {PAGES} from "../constants/pages";
// import { Theme } from "react-native-paper/lib/typescript/types";

const defaultState: IAuth = {
  sessionInfo: {},
  authStatus: AuthStatus.Loading,
  adminAddUserToGroup: async (username: string, groupName: string) => {},
};

export const AuthContext = React.createContext(defaultState);

export const AuthIsSignedIn: React.FunctionComponent = ({ children }: any) => {
  const { authStatus }: IAuth = useContext(AuthContext);
  return <>{authStatus === AuthStatus.SignedIn ? children : null}</>;
};

export const AuthIsNotSignedIn: React.FunctionComponent = ({
  children,
}: any) => {
  const { authStatus }: IAuth = useContext(AuthContext);
  return <>{authStatus === AuthStatus.SignedOut ? children : null}</>;
};

interface IProps {
  config: IAuthAWS;
  // theme?: (ITheme & Theme) | undefined;
  authConfig?: IAuthFunctionalities;
}

const AuthProvider: React.FC<IProps> = (props: any) => {
  const [authStatus, setAuthStatus] = useState(AuthStatus.Loading);
  const [sessionInfo, setSessionInfo] = useState({});
  const [attrInfo, setAttrInfo] = useState([]);
  const [mfaRequired, setMfaRequired] = useState(false);
  const [globalConfig, setGlobalConfig] = useState({});

  const [isMultifactor, setIsMultifactor] = React.useState(false);
  const initialTheme = {
    // ...DefaultTheme,
    ...props.theme,
  };

  const signInCurrentClinician = () => {
    const callback = () => setAuthStatus(AuthStatus.SignedIn);

    store.dispatch(getCurrentClinician(callback));
  };

  const signOutCurrentClinician = () => {
    const callback = () => setAuthStatus(AuthStatus.SignedOut);

    store.dispatch(clearCurrentClinician(callback));
    store.dispatch(clearCurrentPatientRegion(callback));
  };

  const getSession = async () => {
    try {
      return await cognito.getSession();
    } catch (err) {
      throw err;
    }
  };

  const getAttributes = async () => {
    try {
      const attr = await cognito.getAttributes();
      return attr;
    } catch (err) {
      throw err;
    }
  };

  const getSessionInfo = async () => {
    try {
      const session: any = await getSession();
      if (session) {
        setSessionInfo({
          accessToken: session.accessToken.jwtToken,
          refreshToken: session.refreshToken.token,
          idToken: session.idToken.jwtToken,
          role: session.accessToken.payload["cognito:groups"],
        });

        storeData("accessToken", session.accessToken.jwtToken);
        storeData("refreshToken", session.refreshToken.token);
        storeData("role", session.accessToken.payload["cognito:groups"]);
        storeData("idToken", session.idToken.jwtToken);

        // const attr: any = await getAttributes();
        // setAttrInfo(attr);

        signInCurrentClinician();
      }
    } catch (err) {
      signOutCurrentClinician();
    }
  };
  const initCognito = async () => {
    /*
    **
    Configurable params initialization for cognito
    **
    */
    try {
      await cognito.initCognito(props.config);
    } catch (error: any) {
      const message: IMessage = {
        message: error.code,
        description: `Ooops something wrong in the process: ${error.message}`,
        type: "danger",
      };
      sendMessage(message);
    }
  };
  useEffect(() => {
    initCognito();
    /*
    **
    Default theme and authentication config initialization
    **
    */
    const initialConfig = initGlobalConfig(props.authConfig);
    setGlobalConfig({
      ...globalConfig,
      theme: initialTheme,
      authConfig: initialConfig,
      config: props.config,
    });

    /*
    **
    Cognito session initialization
    **
    */

    getSessionInfo();
  }, []);

  if (authStatus === AuthStatus.Loading) {
    return null;
  }

  const signInWithEmail = async (
    username: string,
    password: string,
    callback: () => void
  ) => {
    try {
      const session: any = await cognito.signInWithEmail(
        username,
        password,
        callback,
        setMfaRequired
      );

      if (session) {
        setSessionInfo({
          accessToken: session.accessToken.jwtToken,
          refreshToken: session.refreshToken.token,
          idToken: session.idToken.jwtToken,
          role: session.accessToken.payload["cognito:groups"],
        });

        await storeData("accessToken", session.accessToken.jwtToken);
        await storeData("role", session.accessToken.payload["cognito:groups"]);
        await storeData("refreshToken", session.refreshToken.token);
        await storeData("idToken", session.idToken.jwtToken);

        const data = await adminListGroupsForUser(username);
        const userrole = session.accessToken.payload["cognito:groups"];
        if (
          (data.data?.Groups[0] && userrole.includes(USER_GROUPS.PATIENT)) ||
          userrole.includes(USER_GROUPS.ATHLETE)
        ) {
          console.log("NOT ALLOWED");
          signOutCurrentClinician();
          const err = {
            code: "not authorized role",
            message: "not authorized",
          };
          signOut();
          throw err;
        }
        const attr: any = await getAttributes();
        setAttrInfo(attr);

        return signInCurrentClinician();
      }
      return session;
    } catch (err) {
      signOutCurrentClinician();
      throw err;
    }
  };

  const signInWithEmailnoRedirect = async (
    username: string,
    password: string,
    callback: () => void
  ) => {
    try {
      const session: any = await cognito.signInWithEmail(
        username,
        password,
        callback,
        setMfaRequired
      );
      if (session) {
        setSessionInfo({
          accessToken: session.accessToken.jwtToken,
          refreshToken: session.refreshToken.token,
          idToken: session.idToken.jwtToken,
          role: session.accessToken.payload["cognito:groups"],
        });

        storeData("accessToken", session.accessToken.jwtToken);
        storeData("role", session.accessToken.payload["cognito:groups"]);
        storeData("refreshToken", session.refreshToken.token);
        storeData("idToken", session.idToken.jwtToken);

        const attr: any = await getAttributes();
        setAttrInfo(attr);
        signOutCurrentClinician();
      }
      return session;
    } catch (err) {
      signOutCurrentClinician();
      throw err;
    }
  };

  const signInOTP = async (username: string, password: string) => {
    try {
      await cognito.signInOTP(username, password);

      return signInCurrentClinician();
    } catch (err) {
      signOutCurrentClinician();
      throw err;
    }
  };

  const updatePhone = async (phone: string, username: string) => {
    try {
      return await cognito.updatePhone(phone, username);
    } catch (err) {
      throw err;
    }
  };

  const signInOTPNotRedirec = async (username: string, password: string) => {
    try {
      await cognito.signInOTP(username, password);
      return signOutCurrentClinician();
    } catch (err) {
      signOutCurrentClinician();
      throw err;
    }
  };

  const federatedSignIn = async (
    configAWS: IAuthAWS,
    provider: SocialMedia
  ) => {
    try {
      return cognito.federatedSignIn(configAWS, provider);
    } catch (err) {
      signOutCurrentClinician();
      throw err;
    }
  };

  const signUpWithEmail = async (
    username: string,
    email: string,
    password: string
  ) => {
    try {
      return await cognito.signUpUserWithEmail(username, email, password);
    } catch (err) {
      throw err;
    }
  };

  const signUpAdmin = async (username: string) => {
    try {
      return await cognito.signUpAdmin(username);
    } catch (err) {
      throw err;
    }
  };

  const handleArrayInvite = async( username: string, userType:any ) =>{
      await Promise.all(
        userType.map(async (role:string) => {
          try {
            const userGroups = {
              ...USER_GROUPS,
              CLINICIANS:"clinicians"
            }
            const parsedRole = (userGroups as any)[role.toUpperCase()];
            if(parsedRole){

              await adminAddUserToGroup(username, parsedRole);
            }
          } catch (error) {
            console.log(error);
          }
        })
      );
  }

  const reSendClinicInvite = async (
    username: string,
    userType: any,
    hasRoleArray?: boolean
  ) => {
    try {
      const authRepository = AuthRepository.getInstance();
      const isPatient =
        userType === USER_GROUPS.PATIENT || userType === USER_GROUPS.ATHLETE;
      await authRepository.deleteClinician(username, isPatient);
      await cognito.signUpAdmin(username);
      if (hasRoleArray && Array.isArray(userType)) {
        try {
         await handleArrayInvite( username, userType)
        } catch (error) {
          console.log(error);
        }
    
      } else {
        await adminAddUserToGroup(username, userType);
      }

      return "Invite sended";
    } catch (err) {
      throw err;
    }
  };
  const adminAddUserToGroup = async (username: string, groupName: string) => {
    try {
      return await cognito.addUserToGroup(username, groupName);
    } catch (err) {
      throw err;
    }
  };

  const adminListGroupsForUser = async (username: string) => {
    try {
      return await cognito.listGroupsForUser(username);
    } catch (err) {
      throw err;
    }
  };

  const signUpWithPhone = async ({
    username,
    email,
    password,
    phone_number,
    name,
    firstName,
    lastName,
  }: IUserAuth) => {
    try {
      return await cognito.signUpUserWithPhone(
        username,
        email,
        password,
        phone_number,
        name,
        firstName,
        lastName
      );
    } catch (err) {
      throw err;
    }
  };

  function signOut() {
    cognito.signOut();
    signOutCurrentClinician();
  }

  const verifyCode = async (username: string, code: string) => {
    try {
      return await cognito.verifyCode(username, code);
    } catch (err) {
      throw err;
    }
  };

  const setAttribute = async (attr: any) => {
    try {
      return await cognito.setAttribute(attr);
    } catch (err) {
      throw err;
    }
  };

  const setAttributes = async (attr: IUserAuth) => {
    try {
      return await cognito.setAttributes(attr);
    } catch (err) {
      throw err;
    }
  };

  const sendCodeRecoverPassword = async (username: string) => {
    try {
      return await cognito.sendCodeRecoverPassword(username);
    } catch (err) {
      throw err;
    }
  };

  const sendCode = async (username: string, code: string) => {
    try {
      return await cognito.sendCode(username, code);
    } catch (err) {
      throw err;
    }
  };

  const sendMfaCode = async (username: string, code: string) => {
    try {
      await cognito.sendMfaCode(username, code);
      setMfaRequired(false);
      return true;
    } catch (err) {
      throw err;
    }
  };

  const reSendCode = async (username: string) => {
    try {
      return await cognito.reSendCode(username);
    } catch (err) {
      throw err;
    }
  };

  const reSendMfaCode = async (callback: (sended: boolean) => void) => {
    try {
      return await cognito.reSendMfaCode(callback);
    } catch (err) {
      throw err;
    }
  };

  const enableMFA = async (username: string) => {
    try {
      return await cognito.enableMFA(username);
    } catch (err) {
      throw err;
    }
  };

  const disableMFA = async (username: string) => {
    try {
      return await cognito.disableMFA(username);
    } catch (err) {
      throw err;
    }
  };

  const forgotPassword = async (
    username: string,
    code: string,
    password: string
  ) => {
    try {
      return await cognito.forgotPassword(username, code, password);
    } catch (err) {
      throw err;
    }
  };

  const forgotPasswordToken = async (username: string, password: string) => {
    try {
      return await cognito.forgotPasswordToken(username, password);
    } catch (err) {
      throw err;
    }
  };

  const onChangePhoneSubmitted = async (phone: string, email: string) => {
    try {
      return await cognito.onChangePhoneSubmitted(phone, email);
    } catch (err) {
      throw err;
    }
  };

  const changePassword = async (oldPassword: string, newPassword: string) => {
    try {
      return await cognito.changePassword(oldPassword, newPassword);
    } catch (err) {
      throw err;
    }
  };

  const completeNewPassword = async (
    username: string,
    password: string,
    newPassword: string
  ) => {
    try {
      return await cognito.completeNewPassword(username, password, newPassword);
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  const rememberDevice = async () => {
    try {
      return await cognito.rememberDevice();
    } catch (err) {
      throw err;
    }
  };

  const forgotDevice = async () => {
    try {
      return await cognito.forgotDevice();
    } catch (err) {
      throw err;
    }
  };

  const onConfirmCodeResendCodePhone = async (phone: string, email: string) => {
    try {
      return await cognito.onConfirmCodeResendCodePhone(phone, email);
    } catch (err) {
      throw err;
    }
  };

  const onConfirmCodeSubmitted = async (
    code: string,
    newEmail: string,
    email: string
  ) => {
    try {
      return await cognito.onConfirmCodeSubmitted(code, newEmail, email);
    } catch (err) {
      throw err;
    }
  };

  const onConfirmCodeSubmittedPhone = async (
    code: string,
    phone: string,
    email: string
  ) => {
    try {
      return await cognito.onConfirmCodeSubmittedPhone(code, phone, email);
    } catch (err) {
      throw err;
    }
  };

  const handleRedirection = async () => {
    let sessionInfo: any = await getSession();

    let userCognitoRoles =
        sessionInfo?.accessToken?.payload["cognito:groups"] ?? [];
    if (userCognitoRoles.includes(USER_GROUPS.SUPER_ADMIN)) {
      const queryString = window.location.search;
      console.log(queryString, queryString.includes("cronJobId"));
      if (queryString.includes("cronJobId")) {
        const searchParams = new URLSearchParams(queryString);

        const jobIdValue = searchParams.get("cronJobId");
        window.location.href = `/patient-details/${jobIdValue}?fromCronJob=true`;
      } else {
        window.location.href = PAGES.homeScreen;
      }
    } else if (
        userCognitoRoles.includes(USER_GROUPS.CLINIC_ADMIN) ||
        userCognitoRoles.includes(USER_GROUPS.CLINIC_ASSISTANT) ||
        userCognitoRoles.includes(USER_GROUPS.CLINIC_TEAM_LEAD) ||
        userCognitoRoles.includes(USER_GROUPS.CLINICIAN) ||
        userCognitoRoles.includes(USER_GROUPS.CLINIC_TEAM_MEMBER)
    ) {
      window.location.href = PAGES.homeScreen;
    } else {
      window.location.href = PAGES.patientOverview;
    }
  };

  const state: IAuth = {
    authStatus,
    sessionInfo,
    attrInfo,
    mfaRequired,
    globalConfig,
    isMultifactor,
    signUpWithEmail,
    signInWithEmail,
    signInWithEmailnoRedirect,
    signUpWithPhone,
    signInOTP,
    signInOTPNotRedirec,
    signOut,
    verifyCode,
    getSession,
    sendCode,
    forgotPassword,
    changePassword,
    getAttributes,
    setAttribute,
    setAttributes,
    enableMFA,
    adminAddUserToGroup,
    adminListGroupsForUser,
    reSendCode,
    updatePhone,
    sendCodeRecoverPassword,
    sendMfaCode,
    reSendMfaCode,
    federatedSignIn,
    rememberDevice,
    forgotDevice,
    signUpAdmin,
    forgotPasswordToken,
    storeData,
    onChangePhoneSubmitted,
    completeNewPassword,
    setIsMultifactor,
    onConfirmCodeSubmittedPhone,
    onConfirmCodeResendCodePhone,
    onConfirmCodeSubmitted,
    reSendClinicInvite,
    disableMFA,
    handleRedirection
  };

  return (
    <AuthContext.Provider value={state}>{props.children}</AuthContext.Provider>
  );
};

export const storeData = async (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    throw e;
    // saving error
  }
};

export const getData = async (key: string) => {
  try {
    const value = localStorage.getItem(key);
    if (value !== null) {
      return value;
    }
  } catch (e) {
    throw e;
    // error reading value
  }
};

export const removeData = async (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    throw e;
    // error reading value
  }
};

export const getRoleData = async () => {
  try {
    const value = localStorage.getItem("role");
    if (value !== null) {
      return value.split(",") ?? [];
    }
  } catch (e) {
    return [];
  }
};

export default AuthProvider;
